import { render } from "./UPP.vue?vue&type=template&id=2a1b2652"
import script from "./UPP.vue?vue&type=script&lang=ts"
export * from "./UPP.vue?vue&type=script&lang=ts"
script.render = render

export default script